var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("extra-number-settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("auto-number-products") },
                    on: { input: _vm.save },
                    model: {
                      value: _vm.autoAssignProductSku,
                      callback: function ($$v) {
                        _vm.autoAssignProductSku = $$v
                      },
                      expression: "autoAssignProductSku",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-list",
        [
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.openAutoBarcodeSettings()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("open-auto-barcode-settings")))]
          ),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.resetNumberingForClients()
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$ct("reset-numbering-for", { name: _vm.$ct("clients") })
                )
              ),
            ]
          ),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.resetNumberingForSuppliers()
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$ct("reset-numbering-for", { name: _vm.$ct("suppliers") })
                )
              ),
            ]
          ),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.resetNumberingForProspects()
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$ct("reset-numbering-for", { name: _vm.$ct("prospects") })
                )
              ),
            ]
          ),
          !_vm.hasJournalModule
            ? _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.resetNumberingForPurchases()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$ct("reset-numbering-for", {
                        name: _vm.$ct("purchases"),
                      })
                    )
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.autoBarcodeSettingsOpen,
            callback: function ($$v) {
              _vm.autoBarcodeSettingsOpen = $$v
            },
            expression: "autoBarcodeSettingsOpen",
          },
        },
        [
          _vm.autoBarcodeSettingsOpen
            ? _c("app-auto-barcode-settings", {
                on: {
                  close: function ($event) {
                    _vm.autoBarcodeSettingsOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }